import { Injectable } from '@angular/core';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, finalize } from 'rxjs';
import { CustomModalService } from '@piqet-angular/shared';

@Injectable({
  providedIn: 'root',
})
export class CopyOrganizationService {
  constructor(
    private administratorService: AdministratorService,
    private toaster: ToastrService,
    private modal: CustomModalService
  ) {}

  async copyOrganization(modalId: string, allItemsPayload: any) {
    try {
      const organizationList = await this.administratorService
        .GetAdminOrganizatioList(allItemsPayload)
        .toPromise();
      this.modal.invoke(modalId, {
        initialState: {
          organizationList: organizationList.data.data,
          label: 'Merge organization',
        },
        class: 'modal-xl',
      });
    } catch (error) {
      this.toaster.error('Failed to load organizations. Please try again later.');
    }
  }
}
